import { render } from "./ConfirmView.vue?vue&type=template&id=bfbca3f8"
import script from "./confirm-view-component.ts?vue&type=script&lang=js&external"
export * from "./confirm-view-component.ts?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__